import './Hamburger.css';

const Hamburger = () => (
  <span className="hamburger">
    <span></span>
    <span></span>
    <span></span>
  </span>
);

export default Hamburger;